import { render } from "./Info.vue?vue&type=template&id=4bd736d5"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
script.render = render

export default script